import { CommercialUserProfileProps, CommercialUserProps, FilterUserProps, RegisteredCommercialUserProps, stateStatusType } from './actionType';

export interface FetchCommercialUsersState {
    isLoading: boolean;
    error: string | null;
    commercialUsers: CommercialUserProps[] | null;
    newRegisterUsers: CommercialUserProps[] | null;
    status: stateStatusType | null;
    delete: string | null;
}
export interface FetchCommerciaActivelUsersState {
    isLoading: boolean;
    error: string | null;
    commercialActiveUsers: CommercialUserProps[] | null;
    status: stateStatusType | null;
}
export interface FetchCommerciaUserByIdState {
    isLoading: boolean;
    error: string | null;
    commercialUser: CommercialUserProps | null;
    status: stateStatusType | null;
}
export interface FetchCommerciaUserProfileState {
    isLoading: boolean;
    error: string | null;
    commercialUserProfile: CommercialUserProfileProps | null;
    status: stateStatusType | null;
}
export interface GenericCommercialUserState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}
export interface FilterUserState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
    filteredUser: FilterUserProps | null
}

export const initalCommercialUsersState: FetchCommercialUsersState = {
    isLoading: false,
    error: null,
    commercialUsers: [],
    newRegisterUsers: [],
    status: null,
    delete: null,
};
export const initalCommercialActiveUsersState: FetchCommerciaActivelUsersState = {
    isLoading: false,
    error: null,
    commercialActiveUsers: [],
    status: null,
};
export const initalCommercialUserProfileState: FetchCommerciaUserProfileState = {
    isLoading: false,
    error: null,
    commercialUserProfile: null,
    status: null,
};
export const initalCommercialUserByIdState: FetchCommerciaUserByIdState = {
    isLoading: true,
    error:  null,
    commercialUser:  null,
    status:  null,
}
export const initalGenericCommercialUserState: GenericCommercialUserState = {
    isLoading: false,
    error: null,
    status: null,
};
export const initalFilterUserState: FilterUserState = {
    isLoading: false,
    error: null,
    status: null,
    filteredUser:null
};
export interface CommercialUser {
    commercialUserState: FetchCommercialUsersState;
    commercialActiveUserState: FetchCommerciaActivelUsersState;
    commercialUserProfileState: FetchCommerciaUserProfileState;
    commercialUserByIdState: FetchCommerciaUserByIdState;
    genericCommercialUserState: GenericCommercialUserState;
    filterUserState:FilterUserState
}

export const initialState: CommercialUser = {
    commercialUserState: initalCommercialUsersState,
    commercialActiveUserState:initalCommercialActiveUsersState,
    commercialUserProfileState: initalCommercialUserProfileState,
    commercialUserByIdState:initalCommercialUserByIdState,
    genericCommercialUserState: initalGenericCommercialUserState,
    filterUserState:initalFilterUserState
};

